import React from 'react';
import { connect } from 'react-redux';
import { Table, Col, Row } from 'react-bootstrap';
import { testReportDownload } from 'actions/tests';
import { TooltipIcon, InlinePreloader, DownloadButton } from 'ctia-ui';
import FileStatusInfo from 'components/FileStatusInfo';
import { hasReportDocuments } from 'helpers/RequestTestsHelper';
import { getDocStatus } from 'helpers/DocumentStatus';

const UploadedResults = ({ reports, testReportDownload, request }) => {
  if (!reports.length) return null;
  if (!hasReportDocuments(reports)) return <InlinePreloader />;

  return (
    <div>
      <h3>Uploaded Results</h3>
      <Row>
        <Col xs={1} style={{ width: 165 }}>
          <FileStatusInfo />
        </Col>
        <Col xs={10}>
          <Table responsive striped>
            <thead>
              <tr>
                <th>Status</th>
                <th>Document Title</th>
                <th style={{ width: 150 }} />
              </tr>
            </thead>
            <tbody>
              {reports.map((elem, i) => {
                const status = elem.document.documentstatusid;
                const statusInfo = getDocStatus(status);
                return (
                  <tr key={i}>
                    <td>
                      <TooltipIcon
                        glyph={statusInfo.icon}
                        tipText={statusInfo.title}
                      />
                    </td>
                    <td>{elem.document.title}</td>
                    <td>
                      <DownloadButton
                        size="small"
                        action={testReportDownload.bind(this, elem, request)}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Col>
      </Row>
    </div>
  );
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(
  mapStateToProps,
  { testReportDownload }
)(UploadedResults);



// WEBPACK FOOTER //
// ./src/containers/testResult/UploadedResults.js